import mutations from './mutations';
import Cookies from 'js-cookie';
import assessmentApi from '@/api/assessment';
import { setItem, removeItem } from '@/utility/localStorageControl';
import { notification } from 'ant-design-vue';

const addNotificationSuccess = message => {
  notification.success({
    message: message,
  });
};

const addNotificationError = err => {
  notification.error({
    message: err,
  });
};

const state = () => ({
  login: Cookies.get('logedIn'),
  loading: false,
  error: null,
  data: {},
  showPrivacyPopup: false,
  agreePrivacy: false,
});

const actions = {
  async login({ commit }, payload) {
    try {
      commit('loginBegin');

      let postData = {
        email: payload.email,
        password: payload.password,
      };

      assessmentApi
        .post('login', postData, { headers: { 'Content-Type': 'application/json' } })
        .then(response => {
          if (response.data.profile.is_first_login) {
            commit('loginSuccessAssessmentFirst', postData);
            addNotificationSuccess('Login Pertama Kali Berhasil');
          } else if (response.data.is_password_expired) {
            commit('loginSuccessExpiredPassword', postData);
            addNotificationSuccess('Password Anda Sudah Kadaluarsa, Silahkan Buat Password Baru.');
          } else {
            setItem('access_token', response.data.access_token);
            setItem('profile_plnbb', response.data.profile);
            setItem('permissions', response.data.permissions);
            Cookies.set('logedIn', true);
            commit('loginAssessmentSuccess', true);
            addNotificationSuccess('Login Berhasil');

            /* if (!response.data.has_agreed_privacy_policy) {
              commit('showPrivacyPopup', true);
              addNotificationSuccess('Silakan menyetujui kebijakan privasi.');
            } else { */
            // commit('loginSuccess', true);
            // addNotificationSuccess('Login Assessment Berhasil');
            // }
          }
        })
        .catch(err => {
          commit('loginErr', err);
          addNotificationError(err.response.data.message);
        });
    } catch (err) {
      commit('loginErr', err);
      addNotificationError(err.message);
    }
  },

  async logOut({ commit }) {
    try {
      commit('logoutBegin');
      Cookies.remove('logedIn');
      commit('logoutSuccess', null);
      removeItem('profile_plnbb');
      removeItem('access_token');
      removeItem('permissions');
    } catch (err) {
      commit('logoutErr', err);
    }
  },

  async createPassword({ commit }, payload) {
    try {
      commit('loginBegin');

      let postData = {
        email: payload.email,
        password: payload.password,
        newPassword: payload.newPassword,
      };

      assessmentApi
        .post('create-password', postData, { headers: { 'Content-Type': 'application/json' } })
        .then(response => {
          setItem('access_token', response.data.access_token);
          setItem('profile_plnbb', response.data.profile);
          setItem('permissions', response.data.permissions);
          Cookies.set('logedIn', true);
          commit('loginSuccess', true);
          addNotificationSuccess('Login Berhasil');
        })
        .catch(err => {
          commit('loginErr', err);
          addNotificationError(err.response.data.message);
        });
    } catch (err) {
      commit('loginErr', err);
      addNotificationError(err.message);
    }
  },

  async resetPassword({ commit }, payload) {
    try {
      commit('loginBegin');

      let postData = {
        email: payload.email,
      };

      assessmentApi
        .post('reset-password', postData, { headers: { 'Content-Type': 'application/json' } })
        .then(response => {
          commit('resetPasswordSuccess', true);
          addNotificationSuccess(response.data.message);
        })
        .catch(err => {
          commit('loginErr', err);
          addNotificationError(err.response.data.message);
        });
    } catch (err) {
      commit('loginErr', err);
      addNotificationError(err.message);
    }
  },

  async checkPrivacyPolicy({ commit }, payload) {
    try {
      await assessmentApi.get('check-user-informed-consent', payload).then(response => {
        if (response.data.data !== null) {
          commit('checkPrivacyPolicySuccess', true);
        }
      });
    } catch (err) {
      commit('checkPrivacyPolicyErr', err);
    }
  },

  async loginToken({ commit }, payload) {
    try {
      commit('loginBegin');

      assessmentApi
        .post(
          'verify-token',
          { token: payload.token, userId: payload.userId },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${payload.token}`,
            },
          },
        )
        .then(response => {
          setItem('access_token', response.data.access_token);
          setItem('profile_plnbb', response.data.profile);
          setItem('permissions', response.data.permissions);
          Cookies.set('logedIn', true);
          commit('loginSuccess', true);
          addNotificationSuccess('Login Berhasil');

          // if (!response.data.has_agreed_privacy_policy) {
          //   commit('showPrivacyPopup', true);
          //   addNotificationSuccess('Silakan menyetujui kebijakan privasi.');
          // } else {
          commit('loginAssessmentSuccess', true);
          addNotificationSuccess('Login Berhasil');
          // }
        });
    } catch (err) {
      commit('loginErr', err);
      addNotificationError(err.message);
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
